import {copyTextToClipboard} from "@/lib/lib";
import {useToast} from "vue-toastification";

export default {
    data() {
        return {
            toast: useToast(),
        }
    },
    methods: {
        copyText(text) {
            copyTextToClipboard(text)
                .then(() => {
                    this.toast.success(this.$t('Copy done'));
                })
                .catch((er) => {
                    this.toast.warning(this.$t('errors.Copy error, please copy manually'));
                    console.error('copy error', er);
                })
        },
    }
}